import { render, staticRenderFns } from "./CarrierDestinationPriceFormModal.vue?vue&type=template&id=1f79ed2a&scoped=true&"
import script from "./CarrierDestinationPriceFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationPriceFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f79ed2a",
  null
  
)

export default component.exports